import { UploadExcel as GenericUploadExcel } from '../../components/UploadExcel';
import { AgreementTemplateService } from '../../service/AgreementTemplateService';
import { Service } from '../../service/Service';

export const UploadExcel = ({ display, setDisplay, reloadLazyData, agreementId = null }) => {

  const customService = {
    ...AgreementTemplateService,
    uploadExcel: (formData: FormData) => AgreementTemplateService.uploadExcel(agreementId, formData),
    toFormData: Service.toFormData,
    baseURL: AgreementTemplateService.baseURL,
    entity: AgreementTemplateService.entity
  };

  const handleDownloadTemplate = () => {
    AgreementTemplateService.downloadTemplate(agreementId).then(res => {
      const contentDisposition = res.headers['content-disposition'];
      let fileName = 'template.xlsx';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, '');
        }
      }
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  };

  const columns = [
    { field: 'rowNum', header: 'Dòng dữ liệu', width: 110, dataType: 'number' },
    { field: 'agreementNo', header: 'Mã tài liệu', width: 140 },
    { field: 'agreementName', header: 'Tên tài liệu', width: 200 },
    {
      field: 'success', header: 'Kết quả', width: 100, dataType: 'custom', customCell(rowData: any): any {
        if (rowData.success === 'Y') {
          return <p className="m-0"><i className="true-icon pi pi-check-circle mr-1" /><span>Thành công</span></p>;
        }
        return <p className="m-0"><i className="false-icon pi pi-times-circle mr-1" /><span>Thất bại</span></p>;
      }
    },
    {
      field: 'error', header: 'Mô tả lỗi', minWidth: 250, dataType: 'custom', customCell(rowData: any) {
        return <div style={{ whiteSpace: 'pre-wrap' }}>{rowData.error}</div>;
      }
    }
  ];

  return (
    <GenericUploadExcel
      display={display}
      setDisplay={setDisplay}
      reloadLazyData={reloadLazyData}
      service={customService as any}
      header="Upload file Excel tài liệu"
      resultHeader="Kết quả upload Excel tài liệu"
      columns={columns}
      downloadTemplate={handleDownloadTemplate}
    />
  );
};
